import { useTranslation } from "react-i18next";
import {useFirebaseAnalytics} from "@/hooks/useFirebaseAnalytics";
import { useDownloadUrls } from "@/hooks/useDownloadUrls";

export default function CTASection() {
  const { t } = useTranslation();

  const { appStoreDownloadUrl, apkDownloadUrl } = useDownloadUrls();

  const {
    logEventDownloadAppStore,
    logEventDownloadApk
  } = useFirebaseAnalytics();

  return (
    <section
      id="download"
      className="py-20 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #007AFF 0%, #60AEFF 100%)" }}
    >
      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/5 pointer-events-none" />
      <div className="absolute -bottom-24 -left-16 w-96 h-96 rounded-full bg-white/5 pointer-events-none" />
      <div className="absolute top-1/2 left-1/4 w-48 h-48 rounded-full bg-white/5 pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/20 border border-white/30 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
          <span className="text-white text-xs font-semibold tracking-wide uppercase">{t("cta_badge")}</span>
        </div>

        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 tracking-tight leading-tight">
          {t("cta_title1")}
          <br />
          {t("cta_title2")}
        </h2>

        <p className="text-white/75 text-lg mb-10 max-w-lg mx-auto">
          {t("cta_subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href={appStoreDownloadUrl}
            onClick={() => logEventDownloadAppStore('button_middle')}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-white text-gray-900 font-bold px-8 py-4 rounded-full cursor-pointer whitespace-nowrap hover:bg-gray-50 transition-colors duration-200 text-base shadow-lg"
          >
            <i className="ri-apple-fill text-xl" />
            <div className="text-left">
              <div className="text-gray-500 text-xs leading-none mb-0.5">{t("cta_downloadOn")}</div>
              <div className="text-gray-900 font-bold text-sm leading-none">{t("cta_appStore")}</div>
            </div>
          </a>
          <a
            href={apkDownloadUrl}
            onClick={() => logEventDownloadApk('button_middle')}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-white text-gray-900 font-bold px-8 py-4 rounded-full cursor-pointer whitespace-nowrap hover:bg-gray-50 transition-colors duration-200 text-base shadow-lg"
          >
            <i className="ri-android-fill text-xl text-green-600" />
            <div className="text-left">
              <div className="text-gray-500 text-xs leading-none mb-0.5">{t("cta_downloadApk")}</div>
              <div className="text-gray-900 font-bold text-sm leading-none">{t("cta_android")}</div>
            </div>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 text-white/70 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-star-fill text-yellow-300" />
            <span>{t("cta_rating")}</span>
          </div>
          <span className="hidden sm:block opacity-30">|</span>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line" />
            <span>{t("cta_bankSecurity")}</span>
          </div>
          <span className="hidden sm:block opacity-30">|</span>
          <div className="flex items-center gap-2">
            <i className="ri-lock-line" />
            <span>{t("cta_noHidden")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
